import { ScrollTrigger } from '../globals/gsap';
import { throttle } from 'lodash';

class Slider {
  stateClasses = {
    initted: 'slider--initted'
  };
  
  constructor($el) {
    this.$el = $el;
    this.$textSlider = $('[data-slider="text"]');
    this.$imageSlider = $('[data-slider="image"]');
    this.$index = $('[data-slider="index"]');

    this.sliderWidth = this.$imageSlider.width();
    this.sliderX = this.$imageSlider.offset().left;

    console.log('slider', this);

    this.init();
  }

  init() {
    import(/* webpackChunkName: "slick" */ 'slick-carousel').then(slick => {
      this.$imageSlider.slick({
        autoplay: false,
        autoplaySpeed: 5000,
        loop: true,
        fade: true,
        asNavFor: this.$textSlider,
      });

      // init text slider and sync with image slider
      this.$textSlider.slick({
        loop: true,
        fade: true,
        asNavFor: this.$imageSlider,
      });


      this.$el.addClass(this.stateClasses.initted);

      ScrollTrigger.refresh();
      // ScrollTrigger.update();

      // update index
      this.$imageSlider.on('afterChange', this.updateIndex);

      this.$imageSlider.on('click', this.clickHandler);

      this.$imageSlider.on('mousemove', throttle(this.mouseMoveHandler, 100));

      $(window).on('resize', throttle(this.resizeHandler, 250));
    });
  }

  updateIndex = () => {
    let index = this.$imageSlider.slick('slickCurrentSlide') + 1;

    // make sure the index is always two digits
    index = index.toString().padStart(2, '0');

    this.$index.text(index);
  }

  clickHandler = (e) => {
    // check where the click happend, if its on the left side of the slider, go to previous slide, if its on the right side, go to next slide
    const { sliderWidth, sliderX } = this;
    const clickX = e.clientX - sliderX;
    const percentage = clickX / sliderWidth;

    if(percentage < 0.5) {
      this.$imageSlider.slick('slickPrev');
    } else {
      this.$imageSlider.slick('slickNext');
    }
  }

  mouseMoveHandler = (e) => {
    const { sliderWidth, sliderX } = this;
    const clickX = e.clientX - sliderX;
    const percentage = clickX / sliderWidth;

    if(percentage < 0.5) {
      this.$imageSlider.addClass('cursor--left');
    } else {
      this.$imageSlider.removeClass('cursor--left');
    }
  }

  resizeHandler = () => {
    this.sliderWidth = this.$imageSlider.width();
    this.sliderX = this.$imageSlider.offset().left;
  }
}

export default Slider;